import { render, staticRenderFns } from "./secondTouchTemplate.vue?vue&type=template&id=1a6d4dfa&scoped=true"
import script from "./secondTouchTemplate.vue?vue&type=script&lang=js"
export * from "./secondTouchTemplate.vue?vue&type=script&lang=js"
import style0 from "./secondTouchTemplate.vue?vue&type=style&index=0&id=1a6d4dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d4dfa",
  null
  
)

export default component.exports